import React, { useMemo } from 'react';
import { ErrorMessage, Field } from '@atlaskit/form';
import Textfield from '@atlaskit/textfield';
import Spinner from '@atlaskit/spinner';
import EditorSuccessIcon from '@atlaskit/icon/glyph/editor/success';
import { G500 } from '@atlaskit/theme/colors';

export const ApplyPromocodeField = ({
  isValidating,
  isValid,
  error,
  onChange,
}: {
  isValidating: boolean;
  isValid: boolean;
  error: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  const getElementAfterInput = useMemo(() => {
    if (isValidating) {
      return (
        <div className="mr-8">
          <Spinner size="small" testId="spinner-icon" />
        </div>
      );
    } else if (isValid) {
      return (
        <div className="mr-8">
          <EditorSuccessIcon size="medium" primaryColor={G500} label="" testId="success-icon" />
        </div>
      );
    }
    return null;
  }, [isValidating, isValid]);

  return (
    <Field name="promocode" isRequired label="Vendor promotion">
      {({ fieldProps }) => (
        <>
          <Textfield
            {...fieldProps}
            testId="add-promocode-text-field"
            autoComplete="off"
            placeholder={'Enter vendor promotion'}
            elemAfterInput={getElementAfterInput}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              fieldProps.onChange(event);
              onChange(event);
            }}
          />
          {error ? <ErrorMessage>{error}</ErrorMessage> : null}
        </>
      )}
    </Field>
  );
};
